import React from "react";
import { Route } from "react-router";
import UserNameForm from "./UserNameForm";


export default <>
      <Route path="name" component={UserNameForm}/>
      </>